/**
 * Model for mapping Activity level details.
 *
 * @author pankaj.khurana@vernuso.com
 */
export class ActivityDetails {
    activitySummary: string;
    activityCategory: OrganisationActivityCategory;
    activities: Array<Activity>;
}

export class Activity {
    activityId: number;
    activityValue: string;
    organisationId: number;
}

export class OrganisationActivityCategory {
    orgId: number;
    activityCategory: number;
    activitySubCategory: number;
    realEstateDevelopment: boolean;
    realEstateTransactions: boolean;
    realEstatePropertyServices: boolean;
    royalties: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/activity/activity-details.model.ts